import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../lib/route-guard.js';
import { VendorCreateForm } from '../../modules/vendors/vendor-create-form.js';

export const Route = createFileRoute('/vendors/new')({
  component: NewVendorPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewVendorPage() {
  return (
    <RouteGuard route="/vendors/new">
      <div>
        <VendorCreateForm />
      </div>
    </RouteGuard>
  );
}
